// Short messages for everyone in a room (someone joined, left, dropped, came back, the host changed).
import React from 'react';

export default function Toasts({ list }: { list: { id: number; message: string }[] }) {
  if (!list.length) return null;
  return (
    <div className="site-toasts" role="status" aria-live="polite">
      {list.map(n => <div key={n.id} className="site-toast">{n.message}</div>)}
    </div>
  );
}
